export const WoodieIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className}>
    <path d="M18 50L24 14H40L46 50H18Z" stroke="currentColor" strokeWidth="5" strokeLinejoin="round"/>
    <ellipse cx="32" cy="22" rx="6" ry="3.5" fill="currentColor"/>
    <path d="M32 33L42 39L32 46L22 39L32 33Z" fill="currentColor"/>
  </svg>
);